import { getLookupAsync } from "@serenity-is/corelib";

export interface LanguageSelectionOptions {
    menu: HTMLElement;
    currentLanguage?: string;
}

interface LanguageLookupRow {
    LanguageId?: string;
    LanguageName?: string;
}

// Populates the #s-language-selection-menu dropdown (already rendered by Views/Shared/_Sidebar.cshtml)
// from the Administration.Language lookup, marks the active language, and reloads the page with a
// LanguagePreference cookie set on click. The old HappyVegi.Common.LanguageSelection widget was built
// around a <select> element; the new sidebar markup uses a Bootstrap dropdown <ul> instead, so this is
// a plain init function around that shape rather than a stateful Widget. Called from ScriptInit.ts.
export async function initLanguageSelection(options: LanguageSelectionOptions) {
    var currentLanguage = options.currentLanguage || "en";

    var lookup = await getLookupAsync<LanguageLookupRow>("Administration.Language");

    if (!lookup.items.some(x => x.LanguageId === currentLanguage)) {
        var idx = currentLanguage.lastIndexOf("-");
        currentLanguage = idx >= 0 ? currentLanguage.substring(0, idx) : null;
        if (currentLanguage == null || !lookup.items.some(x => x.LanguageId === currentLanguage))
            currentLanguage = "vi";
    }

    options.menu.innerHTML = "";

    for (const item of lookup.items) {
        var a = document.createElement("a");
        a.className = "dropdown-item" + (item.LanguageId === currentLanguage ? " active" : "");
        a.href = "#";
        a.textContent = item.LanguageName;
        a.addEventListener("click", e => {
            e.preventDefault();
            document.cookie = `LanguagePreference=${encodeURIComponent(item.LanguageId)}; path=/; max-age=${365 * 24 * 60 * 60}`;
            window.location.reload();
        });

        var li = document.createElement("li");
        li.appendChild(a);
        options.menu.appendChild(li);
    }
}
